import styled, { keyframes, css } from "styled-components";
import { darken } from "polished";
import { FiLoader } from "react-icons/fi";

const rotate = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

interface IProps {
  action?: string;
  height?: string;
  fontSize?: string;
  fontWeight?: string;
}

export const Container = styled.div<IProps>`
  span {
    font-size: 15px;
    color: white;
  }
  button {
    border-radius: 4px;
    height: ${(props) => props.height || 'calc(2.125rem + 2px)'};
    border: 0;
    padding: 0 16px;
    color: white;
    font-weight: ${(props) => props.fontWeight || 500};
    font-size: ${(props) => props.fontSize || '1rem'};
    transition: 0.3s;
    cursor: pointer;
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    ${(props) =>
      props.action === "cancel"
        ? css`
            background-color: white;
            border: 2px solid ${props.theme.feedback.error};
            color: ${props.theme.feedback.error};
          `
        : props.action === "return"
        ? css`
            background-color: white;
            border: 2px solid ${props.theme.primary.original};
            color: ${props.theme.primary.original};
          `
        : props.action === "whatsapp"
        ? css`
            background-color: white;
            border: 2px solid ${darken(0.2, props.theme.feedback.success)};
            color: ${darken(0.2, props.theme.feedback.success)};
          `
        : props.action === "success"
        ? css`
            background-color: ${darken(0.08, props.theme.feedback.success_bg)};
            color: ${darken(0.3, props.theme.feedback.success)};
            border: 2px solid ${darken(0.3, props.theme.feedback.success)};

            :hover:enabled {
              background-color: ${darken(0.16, props.theme.feedback.success_bg)};
            }
          `
        : css`
            background-color: ${(props) => props.theme.primary.original};
          `}

    :hover:enabled {
      ${(props) =>
        !props.action &&
        css`
          background-color: ${(props) => props.theme.primary.dark};
        `}

      :hover {
        transform: scale(1.05);
        transition: all 0.2s ease-in-out;
      }
    }
    :disabled {
      cursor: not-allowed;
      background-color: #999;
    }
  }
`;

export const Loader = styled(FiLoader)`
  margin-left: 10px;
  margin: 0 auto;
  font-size: 15px;
  vertical-align: middle;
  color: white;
  animation: ${rotate} 2.5s infinite;
`;
